/* import __COLOCATED_TEMPLATE__ from './oracle-dell-boomi-bom-source.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();